<div class="count-down-timer">
  <div class="count-down-timer-times">
    <p>{{ formatTime(minutes) }}</p>
    <p>:</p>
    <p>{{ formatTime(seconds) }}</p>
  </div>
</div>
